import styled from "styled-components";
import theme from "../../../application/utils/Theme";
import { Field, ErrorMessage } from "formik";

const InputLayoutContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const InputField = styled.input`
        background-color: #F5F5F5;
        width: 100%;
        height: 40px;
        border-radius: 0.2em;
        font-size: 15px;
        font-weight: 500;
        outline: none;
        padding: 0 0.5em;
        letter-spacing: 0.1em;
        @media (min-width: ${theme.breakPoint['tablet']}) {
            font-size: 17px;
            border-radius: 0.4em;
            padding: 2em 0.5em;
        }
    `;

const InputLabel = styled.label`
        color: black;
        opacity: ${props => props.opacity ? props.opacity : "49%"};
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 0.05em;
        white-space: nowrap;
        text-transform:capitalize;
        @media (min-width: ${theme.breakPoint['tablet']}) {
           font-size: 15px;
        }
    `;

const TextError = styled.span`
        color: red;
        font-weight: 500;
        opacity: 40%;
        font-size: 10px;
        @media (min-width: ${theme.breakPoint['tablet']}) {
            font-weight: 600;
           font-size: 15px;
        }
        
    `

function MainInput({ label, name, type, placeholder, ...rest }) {

    return (
        <InputLayout label={label} name={name} >
            <div>
                <Field name={name} placeholder="This is a placeholder" >
                    {({ field }) => <InputField 
                    type={type ? type : "text"} 
                    placeholder={placeholder}
                    {...rest} 
                    {...field} />}
                </Field>
                <ErrorMessage name={name} component={TextError} />
            </div>
        </InputLayout>
    );
}

function InputLayout({ label, name, children }) {
    return (
        <InputLayoutContainer className="w-full">
            {
                label &&
                <div>
                    <InputLabel htmlFor={name}>{label}</InputLabel>
                </div>
            }
            {children}
        </InputLayoutContainer>
    )
}

export { InputLabel, InputField, TextError };
export default MainInput;